import { Link } from "react-router-dom";
import { movieItems, newsItems, varietyItems } from "@/mocks/content";

const shortcuts = [
  {
    to: "/news",
    label: "娱乐资讯",
    desc: "电影 / 剧集 / 明星动态",
    icon: "ri-newspaper-line",
    count: `${newsItems.length} 篇`,
    tone: "bg-primary-50 text-primary-600",
  },
  {
    to: "/recommendations",
    label: "影视推荐",
    desc: "电影与剧集编辑片单",
    icon: "ri-film-line",
    count: `${movieItems.length} 部`,
    tone: "bg-accent-100 text-accent-800",
  },
  {
    to: "/variety",
    label: "综艺动态",
    desc: "播出信息与节目观察",
    icon: "ri-mic-line",
    count: `${varietyItems.length} 档`,
    tone: "bg-secondary-100 text-secondary-800",
  },
  {
    to: "/community",
    label: "互动专区",
    desc: "聊剧、求片、分享感受",
    icon: "ri-chat-smile-3-line",
    count: "热聊中",
    tone: "bg-primary-50 text-primary-600",
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {shortcuts.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/30"
        >
          <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md text-xl ${item.tone}`}>
            <i className={item.icon} />
          </span>
          <span className="min-w-0 flex-1">
            <span className="flex items-center gap-2">
              <span className="font-heading text-sm font-semibold text-foreground-950">{item.label}</span>
              <span className="rounded-sm bg-background-100 px-1.5 py-0.5 font-label text-[10px] text-foreground-500">
                {item.count}
              </span>
            </span>
            <span className="mt-1 block truncate text-xs text-foreground-500">{item.desc}</span>
          </span>
          <i className="ri-arrow-right-up-line text-foreground-300 transition-colors group-hover:text-primary-500" />
        </Link>
      ))}
    </section>
  );
}